__turbopack_context__.v({
  "article": "quoted-tweet-container-module__cim9QG__article",
  "root": "quoted-tweet-container-module__cim9QG__root",
});
